import { downloadCSVFiles, getDateWithTimeString } from '@/helpers/shadcn/utils'
import { useDataTable } from '@/hooks/useDataTable-hook'
import { GetFormattedSalesTargetData } from '@/models/SalesTargetListModel'
import { SalesTargetsColConfig } from '@/services/MockData/SalesTargets/SalesTargetsColConfig'
import { getSalesTargetCsvFile, getSalesTargetsList } from '@/services/salesTargets'
import { useQueries } from '@tanstack/react-query'
import { useMemo, useEffect } from 'react'
export const useSalesTargets = () => {
  const {
    setPageIndex,
    setSortingObj,
    setSearchArry,
    pageIndex,
    sortingObj,
    searchArr,
    handleResetAll
  } = useDataTable()

  // Move search params to request body and only use query params for pagination/sorting
  const queryParams = useMemo(() => {
    const params = new URLSearchParams()

    // Add sorting parameters if available
    if (sortingObj?.column) {
      params.append('sortBy', sortingObj.column)
      params.append('order', sortingObj.direction)
    }

    // Add pagination parameters
    params.append('pageSize', 10)
    params.append('page', pageIndex || 0)

    //this code can be used to filter the data based on the searchArr

    // // Add search parameters if available
    // if (searchArr.length > 0) {
    //   searchArr.forEach(searchObj => {
    //     if (searchObj.type === 'date') {
    //       // params.append(searchObj.field, getFormattedDateString(searchObj.value))
    //     } else {
    //       // params.append(searchObj.field, searchObj.value)
    //     }
    //   })
    // }

    return params.toString()
  }, [sortingObj?.column, sortingObj?.direction, pageIndex])


  // Check if date range is complete
  const isValidDateRange = useMemo(() => {
    if (!searchArr?.length) return true;
    // Find any dateRange type search
    const dateRangeSearch = searchArr.find(s => s.type === 'dateRange');
    // If no dateRange type found, return true (valid)
    if (!dateRangeSearch) return true;
    // For dateRange type, validate it has both start and end dates
    const [startDate, endDate] = dateRangeSearch.value.split(',');
    return Boolean(startDate && endDate && !dateRangeSearch.value.endsWith(','));
  }, [searchArr]);

  const [{ data, isLoading, isFetching }] = useQueries({
    queries: [
      {
        queryKey: ['SALES_TARGETS', queryParams, searchArr],
        queryFn: () => getSalesTargetsList(queryParams, searchArr),
        enabled: isValidDateRange // Only call API when date range is complete
      },
    ],
  })

  const onDownloadBtnClick = async selectedIds => {
    const body = {
      "ids": selectedIds,
      "filters": searchArr,
    }
    const data = await getSalesTargetCsvFile(body)
    const fileName = `SalesTarget_${getDateWithTimeString()}`
    downloadCSVFiles(data, fileName)
  }

  const resultsData = useMemo(() => data || {}, [data])

    // Extract sortBy and order from API response and sync with sortingObj
    useEffect(() => {
      if (resultsData && resultsData.sortBy && resultsData.order) {
        // Only update if different to avoid infinite loop
        if (resultsData.sortBy !== sortingObj?.column || resultsData.order !== sortingObj?.direction) {
          setSortingObj({column: resultsData.sortBy, direction: resultsData.order})
        }
      }
    }, [resultsData, sortingObj, setSortingObj])


  const salesTargetsData = useMemo(() => GetFormattedSalesTargetData(resultsData), [resultsData])
  return {
    salesTargetsColConfigData: SalesTargetsColConfig,
    salesTargetsData,
    pageIndex,
    setPageIndex,
    setSortingObj,
    sortingObj,
    setSearchArry,
    onDownloadBtnClick,
    searchArr,
    isLoading: isLoading || isFetching,
    handleResetAll
  }
}
